import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { AkamProFooterIcon, CloseXIcon, EmptyHeartIcon, HeartIcon, UnlimitedIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { startTimer } from 'modules/blok-test';
import { globalConst, useCountdownTimer, useGetHeartData } from 'modules/global';

import { Visible } from 'components';

interface IProps {
  onClose: () => void;
  open: boolean;
}
const totalHearts = 3;

const HeartModal: React.FC<IProps> = ({ onClose, open }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { heartData, refetch } = useGetHeartData();
  const { remaining, isFinished } = useCountdownTimer({
    startTime: heartData?.heart_spent_at,
    countdownAmount: heartData?.time_left,
    unit: 'hour'
  });
  const hasPremium = useAppSelector(state => state.user.premium);

  useEffect(() => {
    if (heartData?.heart_spent_at) {
      dispatch(startTimer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [heartData?.heart_spent_at]);

  useEffect(() => {
    if (isFinished) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinished]);

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onCancel={onClose}
      width="450px"
      closeIcon={
        <div className="flex items-center justify-center rounded-full bg-gray-800 p-1">
          <CloseXIcon size="12" />
        </div>
      }
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      title={<span className="text-lg">{t('yurak')}</span>}
    >
      <div className="flex items-center justify-center gap-4">
        {Array.from({ length: heartData?.heart_count || 0 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="mt-[.2rem]">
            <HeartIcon size="35" />
          </div>
        ))}
        {Array.from({ length: totalHearts - (heartData?.heart_count || 0) }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <EmptyHeartIcon key={index} />
        ))}
      </div>
      <div className="mt-2 text-center text-base font-semibold text-gray-500">
        <Visible
          if={hasPremium}
          else={
            <Visible if={heartData?.heart_spent_at} else={t('sizning_yuragingiz_tolgan')}>
              <span className="text-red-500">{remaining} </span>
              {t('keyin_yurak_toladi').toLocaleLowerCase()}
            </Visible>
          }
        >
          {t('sizda_cheksiz_yurklar')}
        </Visible>
      </div>

      <div className="mt-5">
        {hasPremium ? (
          <div className="flex items-center justify-between rounded-xl bg-[linear-gradient(135deg,_#00F260_0%,_#0575E6_100%)] p-3.5 text-white shadow-[0px_4px_0px_0px_#136C7F] transition">
            <div className="flex items-center gap-2">
              <EmptyHeartIcon size="24" />
              <AkamProFooterIcon size="90" />
            </div>
            <div className="flex items-center gap-2">
              <span>{t('aktiv')}</span>
              <UnlimitedIcon />
            </div>
          </div>
        ) : (
          <Link href={globalConst.pageNames.PRO} onClick={onClose}>
            <div className="flex cursor-pointer items-center justify-between rounded-xl bg-[linear-gradient(135deg,_#00F260_0%,_#0575E6_100%)] p-3.5 text-white shadow-[0px_4px_0px_0px_#136C7F] transition">
              <div className="flex items-center gap-2">
                <EmptyHeartIcon size="24" />
                <AkamProFooterIcon size="90" />
              </div>
              <UnlimitedIcon />
            </div>
          </Link>
        )}
        {/* {!hasPremium && (
          <>
            <div className="flex cursor-pointer items-center justify-between rounded-xl bg-gray-100 p-3.5 font-medium shadow-[0px_4px_0px_0px_#E4E4E4] transition">
              <div className="flex items-center gap-2">
                <div className="self-center">
                  <HeartIcon size="28" />
                </div>
                <div>
                  <p className="text-base">{t('reklama_korish')}</p>
                  <span className="text-xs text-gray-400">{t('reklama_korish_desc')}</span>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <VideoPlayIcon />
                <span className="text-gray-400">+1</span>
              </div>
            </div>
          </>
        )} */}
      </div>
    </Modal>
  );
};

export default HeartModal;
